<template>
  <page :title="title" :breadcrumb="breadcrumb">
    <div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="tranMode === 'New'">mdi-plus</v-icon>
          <v-icon v-if="tranMode === 'Review'">mdi-pencil</v-icon>
          <v-icon v-if="tranMode === 'Query'">mdi-magnify</v-icon>
          <v-toolbar-title v-if="tranMode === 'New'">New Currency</v-toolbar-title>
          <v-toolbar-title v-if="tranMode === 'Review'">Edit Currency</v-toolbar-title>
          <v-toolbar-title v-if="tranMode === 'Query'">View Existing Currency</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <message :messages="messages"></message>
          <form>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 md6 xs12 v-if="tranMode === 'New'">
                  <v-autocomplete
                    :items="currList"
                    v-model="currForm.curr"
                    :label="labels.curr"
                    item-text="label"
                    item-value="value"
                    data-vv-name="curr"
                    :data-vv-as="labels.curr"
                    :error-messages="errors.collect('curr')"
                    v-validate="'required'"
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg6 md6 xs12 v-else>
                  <v-subheader class="queryLabel">{{ labels.curr }}</v-subheader>
                  <div class="queryValue">{{ currForm.curr }}</div>
                </v-flex>
                <v-flex lg6 md6 xs12 v-if="tranMode === 'Review'">
                  <v-text-field
                    :label="labels.currDesc"
                    v-model="currForm.currDesc"
                    :error-messages="errors.collect('currDesc')"
                    data-vv-name="currDesc"
                    :data-vv-as="labels.currDesc"
                    v-validate="'required|entry|max:40'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 md6 xs12 v-if="tranMode === 'Query'">
                  <v-subheader class="queryLabel">{{ labels.currDesc }}</v-subheader>
                  <div class="queryValue">{{ currForm.currDesc }}</div>
                </v-flex>
                <v-flex lg6 md6 xs12 v-if="tranMode === 'New'">
                  <v-text-field
                    v-model="currForm.rate"
                    v-num-mask="{ negative: false, intScale: 7, decScale: 6 }"
                    :label="labels.rate"
                    :error-messages="errors.collect('rate')"
                    data-vv-name="rate"
                    :data-vv-as="labels.rate"
                    v-validate="'required|mustGreaterThenZero'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 md6 xs12 v-else>
                  <v-subheader class="queryLabel">{{ labels.rate }}</v-subheader>
                  <div class="queryValue">{{ currForm.rate }}</div>
                </v-flex>
                <v-flex lg6 md6 xs12 v-if="tranMode === 'New'">
                  <cal-picker
                    :label="labels.effDate"
                    v-model="currForm.fieldEffDate"
                    :error-messages="errors.collect('effDate')"
                    data-vv-name="effDate"
                    :data-vv-as="labels.effDate"
                    :min="minDate()"
                    v-validate="'required|checkEffDate'"
                  ></cal-picker>
                </v-flex>
                <v-flex lg6 md6 xs12 v-else>
                  <v-subheader class="queryLabel">{{ labels.effDate }}</v-subheader>
                  <div class="queryValue">{{ formatDisplayDate(currForm.effDate) }}</div>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg6 md6 xs12>
                  <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                  <div class="queryValue">{{ currForm.createdName }}</div>
                </v-flex>
                <v-flex lg6 md6 xs12>
                  <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                  <div class="queryValue">{{ formatDisplayDate(currForm.createdDate) }}</div>
                </v-flex>
                <v-flex lg6 md6 xs12 v-if="tranMode !== 'New'">
                  <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                  <div class="queryValue">{{ currForm.modifiedName }}</div>
                </v-flex>
                <v-flex lg6 md6 xs12 v-if="tranMode !== 'New'">
                  <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                  <div class="queryValue">{{ formatDisplayDate(currForm.modifiedDate) }}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-flex xs12 row warp>
          <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
          <v-btn v-if="tranMode !== 'Query'" color="primary" type="submit" @click.prevent="doSaveCurr">
            Save
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-flex>
      </v-card>
      <v-dialog v-model="newCurrDialog" width="800px" persistent>
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-plus</v-icon>
            <v-toolbar-title>New Currency</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <message :messages="messages"></message>
            <form data-vv-scope="newCurrForm">
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field
                      data-vv-scope="newCurrForm"
                      :label="labels.newCurrency"
                      v-model="newCurrForm.curr"
                      :error-messages="errors.collect('newCurrForm.curr')"
                      data-vv-name="curr"
                      :data-vv-as="labels.newCurrency"
                      v-validate="newCurrValidate()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      data-vv-scope="newCurrForm"
                      :label="labels.newCurrDesc"
                      v-model="newCurrForm.currDesc"
                      :error-messages="errors.collect('newCurrForm.currDesc')"
                      data-vv-name="currDesc"
                      :data-vv-as="labels.newCurrDesc"
                      v-validate="newCurrDescValidate()"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" text @click.native="doSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate, removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import { removeFormatNumber } from '@/utils/number.js'

export default {
  data() {
    return {
      breadcrumb: [],
      title: 'Currency Review',
      labels: {
        curr: 'Currency',
        currDesc: 'Description',
        rate: 'Exchange Rate',
        effDate: 'Effective Date',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        newCurrency: 'Currency',
        newCurrDesc: 'Description'
      },
      currForm: {
        curr: null,
        currDesc: null,
        rate: 0,
        effDate: null,
        fieldEffDate: null,
        createdName: '',
        createdDate: null,
        modifiedName: '',
        modifiedDate: null
      },
      newCurrForm: {
        curr: null,
        currDesc: null
      },
      newCurr: false,
      newCurrDialog: false,
      loading: false,
      currList: [{ label: 'New Currency', value: 'create' }],
      newCurrList: []
    }
  },
  watch: {
    'currForm.curr': function (value) {
      if (value === 'create') {
        this.newCurrency = null
        this.newCurrDialog = true
      }
    }
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    currMenu() {
      return this.$store.state.currParam.menu
    },
    curr() {
      return this.$route.params.curr
    },
    effDate() {
      return this.$route.params.effDate
    },
    tranMode() {
      return this.$route.params.tranMode
    }
  },
  methods: {
    minDate() {
      return new Date()
    },
    formatDisplayDate(effDate) {
      return formatDisplayDate(effDate)
    },
    newCurrValidate() {
      if (this.newCurrDialog) {
        return 'required|max:4|checkDupCurr'
      } else {
        return ''
      }
    },
    newCurrDescValidate() {
      if (this.newCurrDialog) {
        return 'required|entry|max:40'
      } else {
        return ''
      }
    },
    doInitForm() {
      this.resetValidator()
      this.resetMessages()
      this.currForm.curr = null
      this.currForm.currDesc = null
      this.currForm.rate = parseFloat(0).toFixed(6)
      this.currForm.effDate = new Date()
      this.currForm.fieldEffDate = new Date()
      this.currForm.createdName = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.currForm.createdDate = new Date()
    },
    async fetchData() {
      this.loading = true
      const apiURI = this.currMenu.getCurrency
      const expand = { curr: this.curr, effDate: this.effDate }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.currForm.curr = data.currency.curr
          this.currForm.currDesc = data.currency.currDesc
          this.currForm.rate = data.currency.rate
          this.currForm.effDate = data.currency.effDate
          this.currForm.createdName = data.currency.createdName
          this.currForm.createdDate = data.currency.createdDate
          this.currForm.modifiedName = data.currency.modifiedName
          this.currForm.modifiedDate = data.currency.modifiedDate
        }
      }
      this.loading = false
    },
    async getCurrList() {
      const apiURI = this.currMenu.initCurrList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          var curr
          for (curr in data.currList) {
            this.currList.push(data.currList[curr])
          }
        }
      }
    },
    doSaveCurr() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newCurr) {
            var createNewCurr = false
            if (this.newCurrList.length !== 0) {
              for (var i in this.newCurrList) {
                if (this.currForm.curr === this.newCurrList[i].curr) {
                  this.currForm.curr = this.newCurrList[i].curr
                  this.currForm.currDesc = this.newCurrList[i].currDesc

                  createNewCurr = true
                  break
                }
              }
            }

            if (createNewCurr) {
              this.doCreateCurrency()
            } else {
              this.doCreateCurrencyRate()
            }
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateCurrency() {
      const apiURI = this.currMenu.createCurrency
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.currForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCreateCurrencyRate()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doCreateCurrencyRate() {
      const apiURI = this.currMenu.createCurrencyRate
      if (apiURI) {
        this.submitting = true
        this.currForm.rate = removeFormatNumber(this.currForm.rate)
        this.currForm.effDate = this.currForm.fieldEffDate.setHours(0, 0, 0, 0)
        try {
          const result = await this.$http.post(apiURI, this.currForm)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.$router.push({ name: 'currency' })
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.currMenu.updateCurrency
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.currForm)
          const { data } = result
          if (data) {
            this.notify(data)
            if (this.newCurr) {
              this.doCreateCurrencyRate()
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doClose() {
      this.resetMessages()
      this.currForm.curr = null
      this.newCurrForm.curr = null
      this.newCurrForm.currDesc = null
      this.newCurrDialog = false
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll('newCurrForm').then((result) => {
        if (result) {
          const currListPush = {
            label: this.newCurrForm.curr + ' - ' + this.newCurrForm.currDesc,
            value: this.newCurrForm.curr
          }
          const newCurrListPush = {
            curr: this.newCurrForm.curr,
            currDesc: this.newCurrForm.currDesc
          }
          this.currList.push(currListPush)
          this.newCurrList.push(newCurrListPush)
          this.currForm.curr = this.newCurrForm.curr
          this.newCurrForm.curr = null
          this.newCurrForm.currDesc = null
          this.newCurrDialog = false
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCancel() {
      this.$router.push({ name: 'currency' })
    }
  },
  created() {
    this.breadcrumb = this.derieveBreadcrumbByName('currency')
    this.breadcrumb.push({
      name: 'currencyReview',
      text: this.title
    })
    if (this.tranMode === 'New') {
      this.newCurr = true
      this.doInitForm()
      this.getCurrList()
    } else {
      this.newCurr = false
      this.fetchData()
    }
    const checkDupCurr = {
      getMessage: (field, args) => {
        return 'Duplicate Currency Found'
      },
      validate: (value, args) => {
        var returnVal = true
        var val = ''
        var currVal = ''
        for (var i in this.currList) {
          val = value.toUpperCase()
          currVal = this.currList[i].value.toUpperCase()
          if (val === currVal) {
            returnVal = false
          }
        }
        for (var j in this.newCurrList) {
          val = value.toUpperCase()
          currVal = this.newCurrList[j].value.toUpperCase()
          if (val === currVal) {
            returnVal = false
          }
        }
        return returnVal
      }
    }
    const mustGreaterThenZero = {
      getMessage: (field, args) => {
        return field + ' must be greater than 0'
      },
      validate: (value, args) => {
        return removeFormatNumber(value) >= 0.000001
      }
    }
    const checkEffDate = {
      getMessage: (field, args) => {
        return 'Effective date cannot be a past date'
      },
      validate: (value, args) => {
        if (value) {
          return isAfter(removeTime(value), removeTime(new Date())) || removeTime(value) >= removeTime(new Date())
        } else {
          return true
        }
      }
    }
    this.$validator.extend('checkDupCurr', checkDupCurr)
    this.$validator.extend('mustGreaterThenZero', mustGreaterThenZero)
    this.$validator.extend('checkEffDate', checkEffDate)
  },
  mixins: [MessageMixin]
}
</script>
